import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import config from '../config';

const Reviews = () => {
  const [reviews, setReviews] = useState([]);
  const [filterOption, setFilterOption] = useState('');
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const reviewsPerPage = 10;

  // Fetch reviews from API
  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const token = localStorage.getItem('accessToken');
        const response = await fetch(`${config.apiBaseUrl}/api/reviews/get`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await response.json();
        setReviews(data.data);
      } catch (error) {
        console.error('Error fetching reviews:', error);
      }
    };

    fetchReviews();
  }, []);

  // Pagination Logic
  const indexOfLastReview = currentPage * reviewsPerPage;
  const indexOfFirstReview = indexOfLastReview - reviewsPerPage;
  const currentReviews = reviews.slice(indexOfFirstReview, indexOfLastReview);

  const handleFilterOptionChange = (e) => {
    setFilterOption(e.target.value);
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleSearchSubmit = () => {
    alert(`Searching for ${filterOption} with text: ${searchText}`);
    // Add search logic if necessary
  };

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(reviews.length / reviewsPerPage);

  return (
    <div className="flex min-h-screen bg-gray-800 text-white">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      <div className="flex-1 lg:ml-0">
        {/* Header with mobile menu button */}
        <div className="bg-gray-900 p-4 lg:hidden">
          <button
            onClick={() => setSidebarOpen(true)}
            className="text-white"
          >
            <div className="w-6 h-6 flex flex-col justify-center items-center">
              <div className="w-5 h-0.5 bg-white mb-1"></div>
              <div className="w-5 h-0.5 bg-white mb-1"></div>
              <div className="w-5 h-0.5 bg-white"></div>
            </div>
          </button>
        </div>

        <div className="p-4 lg:p-6">
          <h1 className="text-2xl lg:text-3xl font-bold mb-6">Review List</h1>

          {/* Search Section */}
          <div className="flex flex-col mb-6 lg:flex-row lg:items-center lg:space-x-4">
            <div className="flex flex-col lg:flex-row lg:items-center lg:space-x-4 mb-4 lg:mb-0">
              <label className="text-sm lg:text-base font-medium mb-2 lg:mb-0">Search by:</label>
              <select
                value={filterOption}
                onChange={handleFilterOptionChange}
                className="p-2 lg:p-2 rounded text-black text-sm lg:text-base mb-4 lg:mb-0"
              >
                <option value="">Select Option</option>
                <option value="name">Name</option>
                <option value="email">Email</option>
              </select>
            </div>
            
            <div className="flex flex-col lg:flex-row lg:items-center lg:space-x-4 lg:flex-1">
              <input
                type="text"
                value={searchText}
                onChange={handleSearch}
                className="p-2 lg:p-2 rounded text-black text-sm lg:text-base mb-4 lg:mb-0 lg:flex-1"
                placeholder="Enter search text"
              />
              <button
                onClick={handleSearchSubmit}
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded text-sm lg:text-base"
              >
                Search
              </button>
            </div>
          </div>

          {/* Desktop Table View */}
          <div className="hidden lg:block overflow-x-auto">
            <table className="min-w-full bg-white text-black rounded-lg overflow-hidden">
              <thead className="bg-gray-200">
                <tr>
                  <th className="py-3 px-4 text-left font-semibold">Customer</th>
                  <th className="py-3 px-4 text-left font-semibold">OrderID</th>
                  <th className="py-3 px-4 text-left font-semibold">Result</th>
                  <th className="py-3 px-4 text-left font-semibold">Star</th>
                  <th className="py-3 px-4 text-left font-semibold">Feedback</th>
                  <th className="py-3 px-4 text-left font-semibold">Post</th>
                  <th className="py-3 px-4 text-left font-semibold">Date</th>
                  <th className="py-3 px-4 text-left font-semibold">Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentReviews.map((review, index) => (
                  <tr key={index} className="border-b border-gray-200 hover:bg-gray-50">
                    <td className="py-3 px-4 max-w-[200px]">
                      <div className="truncate" title={review.book_name}>
                        {review.book_name}
                      </div>
                    </td>
                    <td className="py-3 px-4">{review.bid}</td>
                    <td className="py-3 px-4">
                      <span className={`px-2 py-1 rounded text-xs font-semibold ${
                        review.v_result === 'Completed' ? 'bg-green-100 text-green-800' :
                        review.v_result === 'Pending' ? 'bg-yellow-100 text-yellow-800' :
                        'bg-red-100 text-red-800'
                      }`}>
                        {review.v_result}
                      </span>
                    </td>
                    <td className="py-3 px-4">
                      <div className="flex items-center">
                        <span className="mr-1">⭐</span>
                        <span>{review.star}</span>
                      </div>
                    </td>
                    <td className="py-3 px-4 max-w-[300px]">
                      <div className="truncate" title={review.feedback}>
                        {review.feedback}
                      </div>
                    </td>
                    <td className="py-3 px-4">
                      <span className={`px-2 py-1 rounded text-xs font-semibold ${
                        review.post ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                      }`}>
                        {review.post ? 'Yes' : 'No'}
                      </span>
                    </td>
                    <td className="py-3 px-4">{new Date(review.date).toLocaleDateString()}</td>
                    <td className="py-3 px-4">
                      <a href={`/bookings/${review.bkid}`}>
                        <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded text-sm">
                          View
                        </button>
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Card View */}
          <div className="lg:hidden space-y-4">
            {currentReviews.map((review, index) => (
              <div key={index} className="bg-white text-black rounded-lg p-4 shadow-md">
                <div className="flex justify-between items-start mb-3">
                  <div className="flex-1">
                    <h3 className="font-semibold text-lg mb-1 break-words">{review.book_name}</h3>
                    <p className="text-sm text-gray-600">Order ID: {review.bid}</p>
                  </div>
                  <span className={`px-2 py-1 rounded text-xs font-semibold ml-2 ${
                    review.v_result === 'Completed' ? 'bg-green-100 text-green-800' :
                    review.v_result === 'Pending' ? 'bg-yellow-100 text-yellow-800' :
                    'bg-red-100 text-red-800'
                  }`}>
                    {review.v_result}
                  </span>
                </div>
                
                <div className="mb-3">
                  <div className="flex items-center mb-2">
                    <span className="mr-2">⭐</span>
                    <span className="font-medium">{review.star} stars</span>
                  </div>
                  <p className="text-sm text-gray-700 break-words">{review.feedback}</p>
                </div>
                
                <div className="flex justify-between items-center text-sm text-gray-600 mb-3">
                  <span>Posted: {review.post ? 'Yes' : 'No'}</span>
                  <span>{new Date(review.date).toLocaleDateString()}</span>
                </div>
                
                <div className="flex justify-end">
                  <a href={`/bookings/${review.bkid}`}>
                    <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded text-sm">
                      View Details
                    </button>
                  </a>
                </div>
              </div>
            ))}
          </div>

          {/* Pagination Controls */}
          <div className="flex flex-col lg:flex-row justify-between items-center mt-6 space-y-4 lg:space-y-0">
            <div className="text-sm lg:text-base text-center lg:text-left">
              Showing {indexOfFirstReview + 1} to{' '}
              {Math.min(indexOfLastReview, reviews.length)} of {reviews.length} reviews
            </div>
            <div className="flex items-center space-x-2">
              <button
                onClick={() => paginate(currentPage - 1)}
                disabled={currentPage === 1}
                className="bg-gray-500 hover:bg-gray-700 disabled:opacity-50 text-white font-bold py-2 px-3 lg:px-4 rounded flex items-center text-sm lg:text-base"
              >
                <span>←</span>
                <span className="hidden lg:inline ml-1">Previous</span>
              </button>
              
              <div className="flex items-center space-x-2">
                <span className="text-sm lg:text-base">
                  Page {currentPage} of {totalPages}
                </span>
              </div>
              
              <button
                onClick={() => paginate(currentPage + 1)}
                disabled={indexOfLastReview >= reviews.length}
                className="bg-gray-500 hover:bg-gray-700 disabled:opacity-50 text-white font-bold py-2 px-3 lg:px-4 rounded flex items-center text-sm lg:text-base"
              >
                <span className="hidden lg:inline mr-1">Next</span>
                <span>→</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reviews;